import buttonIconAll from './ButtonIconAll.svg';
import buttonIconError from './ButtonIconError.svg';
import buttonIconWarning from './ButtonIconWarning.svg';
import buttonIconNormal from './ButtonIconNormal.svg';
import buttonIconSettings from './ButtonIconSettings.svg';

import chevronLeftIcon from './ChevronLeftIcon.svg';
import lightChevronLeftIcon from './LightChevronLeftIcon.svg';
import lightChevronRightIcon from './LightChevronRightIcon.svg';

import searchIcon from './SearchIcon.svg'
import closeIcon from './CloseIcon.svg'

const toolbarIconLibrary = {
    buttonIcons: {
        all: buttonIconAll,
        error: buttonIconError,
        warning: buttonIconWarning,
        normal: buttonIconNormal,
        settings: buttonIconSettings,
    },
    chevron: {
        left: chevronLeftIcon,
    },
    lightChevron: {
        left: lightChevronLeftIcon,
        right: lightChevronRightIcon,
    },
    search: {
        searchIcon: searchIcon,
        closeIcon: closeIcon
    },
}

export default toolbarIconLibrary;